import { formDataToJson } from 'client/utils/helpers/Enquiry/Enquiry';
import GeoJSON from 'ol/format/GeoJSON';
import { MAP_PAGE } from 'client/utils/routes/routeConstants';
import { redirect } from 'react-router';

const action = async ({ request }) => {
    if (request.method !== 'POST') {
        redirect(MAP_PAGE);
        return {};
    }
    const formData = await request?.formData();
    const enquiry = formDataToJson(formData);
    const geometry = enquiry?.geometry;
    // kick user out if no geometry
    if (!geometry) {
        redirect(MAP_PAGE);
        return {};
    }

    const aoi = new GeoJSON().readFeature({ geometry: { ...geometry }, type: 'Feature' });

    return { enquiry, aoi };
};

export default action;
